import React from "react";
import { ProgressBar } from "primereact/progressbar";
import Button from "../inputs/button";
import PropTypes from "prop-types";

function BulkProgressIndicator({ state, onCancel, label }) {
	if (!state || state.total <= 1) return null;
	if (state.status !== "running" && state.status !== "completed" && state.status !== "cancelled") return null;

	const failedLabel = state.failed > 0
		? <span className="bulk-progress__errors"> ({state.failed} failed)</span>
		: null;

	return (
		<div className="bulk-progress">
			<div className="bulk-progress__label p3">
				{label ?? `${state.completed} of ${state.total} completed`}{failedLabel}
			</div>
			<ProgressBar
				value={state.percentage}
				showValue={false}
				style={{ height: "8px" }}
				color="#9aca3c"
			/>
			{state.status === "running" && onCancel && (
				<div className="bulk-progress__cancel">
					<Button
						loaded={false}
						onClick={onCancel}
						text="Cancel"
						style="light"
						type="button"
						disabled={false}
					/>
				</div>
			)}
		</div>
	);
}

BulkProgressIndicator.propTypes = {
	state: PropTypes.shape({
		status: PropTypes.string,
		total: PropTypes.number,
		completed: PropTypes.number,
		failed: PropTypes.number,
		percentage: PropTypes.number,
	}),
	onCancel: PropTypes.func,
	label: PropTypes.string,
};

export default BulkProgressIndicator;
